import { mergeSx } from "@/utils/styleHelpers";
import { type ReactElement, useMemo } from "react";

import type { DeeplyNestedSx, FramedLogoProps } from "@/types";

import { FramedLogo } from "../FramedThings";
import { framedComponentSx } from "./styles";

export function StickerFramedLogo<
  RC extends ReactElement | undefined = undefined,
>({ sx, emphasized = true, size = "small", ...props }: FramedLogoProps<RC>) {
  const mergedSx = useMemo(
    () =>
      mergeSx(
        framedComponentSx,
        {
          ...(emphasized
            ? ({
                boxShadow: ({ base }) =>
                  `0 0 0 ${base.border.size[200]} ${base.color.translucent.inverse[1000]}`,
              } as DeeplyNestedSx)
            : {}),
        },
        sx,
      ),
    [sx, emphasized],
  );
  return (
    <FramedLogo {...props} sx={mergedSx} emphasized={emphasized} size={size} />
  );
}

StickerFramedLogo.displayName = "Sticker.FramedLogo";
